import API from './api';

const BlogService = {
  // Public endpoints
  getAllBlogs: async (page = 1, limit = 9, category = null) => {
    try {
      let url = `/public/blog?page=${page}&limit=${limit}`;
      if (category) {
        url += `&category=${category}`;
      }
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getBlogBySlug: async (slug) => {
    try {
      const response = await API.get(`/public/blog/${slug}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getRecentBlogs: async (limit = 5) => {
    try {
      const response = await API.get(`/public/blog/recent?limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  searchBlogs: async (keyword, limit = 20) => {
    try {
      const response = await API.get(`/public/blog/search?q=${encodeURIComponent(keyword)}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getBlogsByCategory: async (category, limit = 20) => {
    try {
      const response = await API.get(`/public/blog/category/${category}?limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Admin endpoints
  adminGetAllBlogs: async (status = null, category = null) => {
    try {
      let url = '/admin/blog';
      const params = [];
      if (status) params.push(`status=${status}`);
      if (category) params.push(`category=${category}`);
      if (params.length) url += '?' + params.join('&');
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  adminGetBlogById: async (id) => {
    try {
      const response = await API.get(`/admin/blog/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  adminCreateBlog: async (blogData) => {
    try {
      const response = await API.post('/admin/blog', blogData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  adminUpdateBlog: async (id, blogData) => {
    try {
      const response = await API.put(`/admin/blog/${id}`, blogData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  adminDeleteBlog: async (id) => {
    try {
      const response = await API.delete(`/admin/blog/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  adminUploadImage: async (file, type) => {
    try {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('type', type);
      const response = await API.post('/admin/blog/upload-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default BlogService;